import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version1.5 NewsDetail画面新規追加
 * NewsDetail SeeMoreNews Card Component
 */
const NewsDetailSeeMoreNewsCard = ({ screenId, apiRequest, controlSettings, messageList, newsList}) => {

  // スタイル
  const theme = useTheme();
  const navigate = useNavigate();
  const isPc = useMediaQuery(mediaQuery.pc);

  const navigateNewsPage = (newsId, url, newsType) => {
    if (newsType === constants.NewsType.InternalNews) {
      // InternalNews
      navigate(`/MyM102/MyM501/MyM502/${newsId}`);
      return;
    } else {
      // GlobalSiteNews
      apiRequest.requestJson('api/news/external-link-transition?newsId=' + newsId, 'GET', null, null, null);
      window.open(url, '_blank');
    }
  }

  const NewsListItem = ({ newsId, date, newsType, url, title, }) => {

    return (
      <Box>
        <MyMLabel>{date}
          <MyMImage
            screenId={screenId}
            filePath={newsType === constants.NewsType.GlobalNews ? 'corporate_icon.png' : 'gm_original_icon.png'}
            alt={newsType === constants.NewsType.GlobalNews ? "CorporateIcon" : "GM Original Icon"}
            width="60px"
            height="20px"
            display="block"
            sx={{ opacity: "0.5", zIndex: "10" }}
          />
        </MyMLabel>
        <MyMLink
          onClick={() => { navigateNewsPage(newsId, url, newsType) }}
          sx={{ color: "#000", fontWeight: "bold", textDecorationColor: "#000", textAlign: "left" }}>
          {title}
        </MyMLink>
        <hr></hr>
      </Box>
    );
  };

  return (
    <OutlinedCustomCard sx={{ height: 'auto'}}>
      <CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: '7%' }}
        title={<MyMVariantLabel variant='h6' sx={{ color: 'white' }}>{controlSettings.LabelList.lblSeeMoreNewsTitle}</MyMVariantLabel>}
      />
      <CardContent sx={{ maxHeight: isPc ? '500px' : '100%', overflowY: "auto" }}>
        {
          newsList.length > 0 ?
            <>
              {
                newsList.map((item, index) => {
                  return (
                    <NewsListItem
                      key={index}
                      newsId={item.NewsId}
                      date={item.FormatPublishDate}
                      newsType={item.NewsType}
                      url={item.Url}
                      title={item.Title}
                    ></NewsListItem>
                  )
                })}
            </>
            :
            <MyMLabel sx={{ margin: "1vw" }}>{messageList.MyM_MSG_I_0059}</MyMLabel>
        }
      </CardContent>
    </OutlinedCustomCard>
  );
}
export default NewsDetailSeeMoreNewsCard;
